import { gql } from '@apollo/client';

import CompanyInvoiceInformationCardFragment from "../../../fragments/SalesDocuments/companyInvoiceInformationCardFragment";

const GET_COMPANY_INVOICE_INFORMATION_CARD = gql`query getCompanyInvoiceInformationCard($companyId: Int!, $cardId: Int!) {
	companyAdminContext {
		salesDocuments {
			getCompanyCard(companyId: $companyId, cardId: $cardId) {
				success
				card {
					...CompanyInvoiceInformationCardFragment
				}
			}
		}
	}
}
${CompanyInvoiceInformationCardFragment}
`

export default GET_COMPANY_INVOICE_INFORMATION_CARD;